import { requestMain, requestCommon, requestBase } from '@/apis/index';
import { CoupeSDK } from '@hll/coupe-sdk';
import { ENV } from '@/config/env';

interface GetCityInfoDataParams {
  city_id: number;
  district_id?: number;
}

// 获取用户信息
export const getUserInfo = () => {
  const params = {
    _m: 'user',
    _a: 'info',
  };
  return requestMain('', {
    method: 'get',
    params,
  });
};

// 获取服务类型列表
export const getServiceTypeList = () => {
  return requestBase('/paganiSoa/customEp/queryServerInfo', {
    method: 'post',
  });
};

export const getDepart = () => {
  const params = {
    _m: 'depart',
    _a: 'item_list',
  };
  return requestMain('', {
    method: 'get',
    params,
  });
};

// 获取开启货运资质认证的白名单
export function getLicenseWhiteList() {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'license_get_white_list',
    },
  });
}

// 获取是否为白名单手机号
export function getPhoneLicenseWhiteList() {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'license_is_white',
    },
  });
}

// 获取对账工具权限
export function getCheckToolAuth() {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'order_bill_switch',
    },
  });
}
// 获取已开通城市列表
export const getOpenedCityList = () => {
  return requestMain(
    '',
    {
      params: {
        _m: 'new_city_list',
      },
    },
    true
  );
};

// 获取城市信息
export const getCityInfoBeta = (data: GetCityInfoDataParams) => {
  return requestMain(
    '',
    {
      method: 'post',
      params: {
        _m: 'city_info',
      },
      data,
    },
    true
  );
};

export const getAllCityList = () => {
  return requestMain(
    '',
    {
      method: 'post',
      params: {
        _m: 'new_all_city_list',
      },
    },
    true
  );
};
// 查询当前用户菜单权限
export function getUserMenuAuth() {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'user_menu_permission',
    },
  });
}

// 查询用户菜单是否展示优惠券包标签
export const getEpWelfareInfo = () => {
  return requestBase('/eucSoa/ep/getEpWelfareInfo', {
    method: 'post',
  });
};
// 查询企业是否有下单审批权限
export const getOrderApproveAuth = () => {
  return requestBase('/eucSoa/ep/getEpSpecialConfig', {
    method: 'post',
  });
};

/**
 * 初始化coupe静态配置
 * '1e649c2c4df345388cfcb96418df16c3': 公共规则配置
 * coupe配置项目详情链接：https://coupe-v.huolala.cn/schema/367/detail
 */
export async function getCoupeData<T>(params: {
  coupeId: string;
  name?: string;
}): Promise<T> {
  return new Promise((resolve) => {
    let coupeEnv = 'prd';
    if (ENV) {
      coupeEnv = ENV === 'prod' ? 'prd' : ENV;
    }
    // 实例化 sdk
    const sdk = new CoupeSDK({
      ...params,
      env: coupeEnv,
    });
    // 调用 fetch 获取数据
    sdk.fetch().then((data) => {
      resolve(data as T);
    });
  });
}

/**
 * 灰度控制公共接口
 * @param { data } data
 * grayscaleKey: 'pc_big_screen' 数据大屏灰度
 */
export function getCommonGrayControl(data: any) {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'common_grayscale_control_v2',
    },
    data,
  });
}

// 提示查询
export function getUserRemind(data: any) {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'common.remind.list',
        data: {
          ...data,
        }
      },
    },
    false,
    'euc'
  )
}
// 更新提示是否点击过
export function setUserRemind(data: any) {
  return requestMain('', {
    method: 'POST',
    params: {
      _a: 'remind_update',
      _m: 'user',
    },
    data,
  });
}

// 获取当前账号是否展示部门管理
// export function getDepartDisplay() {
//   return requestMain('', {
//     method: 'POST',
//     params: {
//       _m: 'depart_is_display',
//     },
//   });
// }
// pagani 城市列表
export function getJavaCities() {
  return requestMain('', {
    method: 'get',
    params: {
      _m: 'pagani_city_list',
    },
  });
}
// pagani 订单状态 和 支付列表
export function getOrderBase() {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'pagani_order_base',
    },
  });
}
// pagani 国标车型
export function getStandardVehicleList() {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'pagani_vehicle_list',
    },
  });
}
// 批量获取灰度配置
export function getGrayScaleBatch(grayscaleKeys: string[]) {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'common.grayscaleV2.control.batch',
        data: {
          os: 'pc',
          grayscaleKeys,
        },
      },
    },
    false,
    'euc'
  );
}

interface GetEpInfoParamType {
  loginIntroduceAndModeSelect?: number;
}

// 获取企业版本、权益包
export function getEpVersionAndPackage(data: GetEpInfoParamType = {}) {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'ep.version.getInfoByEpId',
        data: {
          equityFlag: 1, // 写死，app用的，app旧版不传
          ...data,
          os: 'pc',
        },
      },
    },
    true,
    'euc'
  );
}

interface RegisterBookParams {
  epName: string;
  licenseNo: string;
}
// 创建登记簿 status 0: 未开通 1: 处理中 2: 成功
export function openRegisterBook(data: RegisterBookParams) {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'out.fund.account.open',
        data,
      },
    },
    true,
    'euc'
  );
}

// 获取企业关联信息
export function getEpRelationIdentityApi() {
  return requestMain(
    '',
    {
      method: 'get',
      params: {
        _m: 'relation_get_ep_identity',
      },
      data: {},
    },
    true
  );
}

export interface uploadConfig {
  pic: string;
}
export function imageUploadGetFullPath(data: uploadConfig) {
  return requestBase('/eucImgUpload', {
    method: 'post',
    data: {
      name: 'image.upload.get.full.path',
      data: {
        ...data
      },
    },
  })
}

// 货物类型搜索
type BaseResType = {
  ret: number;
  msg: string;
}

export type SearchItemType = {
  cargo_second_id?: number;
  cargo_second_name?: string;
  cargo_third_id: number;
  cargo_third_name?: string;
};

export type SearchResType = BaseResType & {
  data: {
    cargo_type_list: SearchItemType[];
  };
};
// 货物类型搜索
export function searchOrderCargeTypeApi(data: {search_content: string}): Promise<SearchResType> {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'order.cargo.type',
        data,
      },
    },
    false,
    'eoc'
  );
}

// 获取账期相关页面url
export function getAccountPeriodPageUrls() {
  return requestBase('/efcSoa/loanAccount/getEpLoanAccountUrlList', {
    method: 'post',
  });
}

/**
 * @desc: 获取政府补贴券配置
 * @param { city_id: number | string }
 */
export function getGovtSubsidyCouponConfig(params = {}) {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'task.center.guide',
        data: params,
      },
    },
    false,
    'epll'
  );
}

/**
 * 领取政府补贴券 order.claimGovtSubsidyDiscount
 */
export function getGovtSubsidyDiscount() {
  return requestCommon(
    {
      method: 'post',
      data: {
        name: 'order.claimGovtSubsidyDiscount',
      },
    },
    false,
    'epll'
  );
}

/**
 * 路径规划（order.driver.path.planing）
 * @param data 业务入参：lat_lon_start / lat_lon_end 为 { lat, lon }；途经点 waypoints 为 `lng,lat;lng,lat`
 * @param options showError: 为 false 时不弹业务错误（地图等场景可静默降级）；timeout: 请求超时（ms）
 */
export function getDriverPathPlanning(
  data: any,
  options?: { showError?: boolean; timeout?: number }
) {
  return requestCommon(
    {
      method: 'post',
      showError: options?.showError,
      timeout: options?.timeout,
      data: {
        name: 'order.driver.path.planing',
        data,
      },
    },
    true,
    'eoc'
  );
}
